import { useP2GQuery } from '@parcel2go/npm-p2g-app';
import { useAuth } from 'react-oidc-context';
import { GetSocketSessionId } from '~/apps/smartsend/lib/helpers/AuthHelper';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { ArchivedOrder } from './types';

export const useArchivedOrders = (take: number, skip: number) => {
  const { user } = useAuth();
  const featureEnabled = SettingsCache.settings.Features.includes('ArchivedOrders');

  const { response, isLoading, error } = useP2GQuery<ArchivedOrder[]>({
    session: GetSocketSessionId(user?.profile),
    query: 'account_legacy_orders',
    parameters: { take: String(take), skip: String(skip) },
    enabled: featureEnabled && !!user?.profile
  });

  const orders = response ?? [];
  const totalCount = orders[0]?.TotalCount;
  // Fallback if the query doesn't return TotalCount - estimate one more page while a full page comes back.
  const itemCount =
    typeof totalCount === 'number' ? totalCount : skip + orders.length + (orders.length === take ? take : 0);

  return { orders, itemCount, isLoading, error, featureEnabled } as const;
};
